import store from "@/store/index"
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { cleanStatusAndTimerForLogout } from "../libs/utils"
import { logError } from "./netAxios"
const baseURL: string = window.config.phpUrl

let service: AxiosInstance = Axios.create({
  method: "POST",
  baseURL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  timeout: 50000,
})

interface responseType {
  code: number
  data: any
  msg: string
}

// request拦截器
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    store.commit("handleShowLoading", true)
    config.headers["Token"] = store.state.options.token
    config.headers["merchId"] = store.state.merchId
    config.headers["oauth2-type"] = store.state.options.oauthType
    config.headers[
      "timeZone"
    ] = Intl.DateTimeFormat().resolvedOptions().timeZone
    return config
  },
  (error: any) => {
    store.commit("handleShowLoading", false)
    // Do something with request error
    console.error("error:", error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    if (response.data.code * 1 === 401) {
      cleanStatusAndTimerForLogout()
    }
    // store.commit('handleShowLoading', false)
    return response
  },
  (error: any) => {
    store.commit("handleShowLoading", false)
    if (
      error.response &&
      error.response.data &&
      error.response.data.ErrorText
    ) {
      window.Vue.$message.show({
        text: error.response.data.ErrorText,
      })
    }
    try {
      logError(error)
    } finally {
      return Promise.reject(error)
    }
  }
)

export default service
